
import { PopperButton } from './popper_button';
type ReportMenuButtonProps = {
  options: any[]; 
  onSelect: (itemSelected: any) => void; 
  buttonLabel?: string;
  wrapperClassName?: string;
};

export const ReportMenuButton = ({
  options,
  onSelect,
  buttonLabel = 'Relatórios',
  wrapperClassName = 'w-[7rem]',
}: ReportMenuButtonProps) => {
  
  if (!options || options.length === 0) return null;

  return (
    <div className={wrapperClassName}>
      <PopperButton
        buttonLabel={buttonLabel}
        buttonColor="yellow"
        options={options}
        onSelect={onSelect}
      />
    </div>
  );
};